import { fromExtent } from 'ol/geom/Polygon'
import TileWMS from 'ol/source/TileWMS'

import { blurredButton } from './controls/mapLayers'
import { materializeToast } from './notifications'
import { getLayerById, map } from './map/tools'
import { requestNibToken } from './tokens'

ortoWMS.addEventListener('change', (event) => {
  if (event.target.checked) {
    getOrtoPhotoProjects();
  } else {
    ortoPhotoProjects.disabled = true;
    ortoPhotoProjects.selectedIndex = 0; // or select.value = 'none';
  }
});

const keepFocusOnBtn = (e) => {
  // console.log('Keep focus', e);
  if (e.target.id !== 'wmsUrlField') blurredButton?.focus();
};

mapLayerSelector.onclick = keepFocusOnBtn;
ortoPhotoProjects.onclick = (event) => event.stopPropagation();
ortoPhotoProjects.onchange = () => chooseOrtoPhotoProject(ortoPhotoProjects.value);


export function getOrtoPhotoProjects() {
  // console.log(ortoWMS.checked);
  if (!ortoWMS.checked) return;
  // console.log('getOrtoPhotoProjects');
  const selectList = document.getElementById('ortoPhotoProjects');
  selectList.disabled = false;

  const v = map.getView();
  const e = v.calculateExtent(map.getSize());
  const projection = v.getProjection().getCode().split(':')[1];

  requestNibToken().then(t => fetch(`${import.meta.env.VITE_NIB_PROSJEKTER}?token=${t}`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({
      geometry: { type: 'Polygon', coordinates: fromExtent(e).getCoordinates() },
      projects: [],
      inputWkid: Number(projection),
      outputWkid: Number(projection),
      returnMetadata: true,
      returnGeometry: false,
      inCacheOnly: false,
      stopOnCover: false
    })
  }).then(r => r.json()).then(ortoPhoto => {
    const array = ortoPhoto.projects;
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/remove
    const sl = selectList.length;
    for (let i = sl - 1; i > 0; i--) {
      if (i !== selectList.selectedIndex) selectList.remove(i);
      else selectList.options.item(selectList.selectedIndex).hidden = true;
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/add
    const al = array.length;
    for (let i = 0; i < al; i++) {
      const project = array[i].projectName;
      // const viewString = (ai.length > 50) ? ai.substr(ai.length - 50) : ai;
      // new Option(text, value, defaultSelected, selected):
      selectList.add(new Option(project.substr(0, 50), project));
      selectList.lastElementChild.onclick = keepFocusOnBtn;
    }
  }).catch(e => materializeToast(
    'FlyfotoProsjekter feilet! Kunne ikke hente data fra Norge i Bilder',
    'error'
  )));
}

const chooseOrtoPhotoProject = project => {
  requestNibToken().then(t => getLayerById('ortoWMS').setSource(new TileWMS({
    url: `${import.meta.env.VITE_NIB_WMS}?token=${t}`,
    params: { LAYERS: project, TRANSPARENT: true, VISIBLE: true }
  })));
};
